import React, { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext(null);

export function ThemeProvider({ children }) {
  const [colorTheme, setColorTheme] = useState(() => localStorage.getItem('wf_color_theme') || 'dark');

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', colorTheme);
    document.documentElement.setAttribute('data-color-theme', colorTheme);
    // Keep 'grafana' as the default UI style for aesthetics
    document.documentElement.setAttribute('data-ui-theme', 'grafana');
    localStorage.setItem('wf_color_theme', colorTheme);
  }, [colorTheme]);

  const cycleColorTheme = () => {
    setColorTheme(current => current === 'light' ? 'dark' : 'light');
  };

  const cycleStyleTheme = () => {}; // Removed, kept as no-op for compatibility

  const dark = colorTheme === 'dark';

  return (
    <ThemeContext.Provider value={{
      dark,
      colorTheme,
      cycleColorTheme,
      styleTheme: 'grafana',
      cycleStyleTheme,
      toggle: cycleColorTheme
    }}>
      {children}
    </ThemeContext.Provider>
  );
}

export const useTheme = () => useContext(ThemeContext);

